(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 83542:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(23226);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96088:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/basedash.fb1a5610.png","height":132,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEUUFBRMaXEUFBQUFBQVFRUVFRUg6cLcAAAABnRSTlM/AGcwhiPWrtZ8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAG0lEQVQImWNgYWFmYGZgYGBgYmIFUQwMjFAAAAIiACDE01x9AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 12066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/impira.e073a466.png","height":123,"width":537,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAASAQCkAAAAB3RSTlM/RjFebSNWGXPk5gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUCJljYGRiZGBkZmBkYGFlYGJhZmADAAD5ACJt8n73AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 29358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/knock.f920fb7c.png","height":111,"width":350,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUEBAQNBQQHBAQEBARMaXEEBAQEBAQEBAQAAwQrY+akAAAACXRSTlOPagqoAJqFgEHVxxVnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgYQJBDkYGRgY2djZGBlYGBnZWZmYGNmYABEoAUT4VhGgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 75428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/mage.a68f0773.png","height":142,"width":570,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEUAAAAAAAAAAAAAAAAAAABPDueNAAAABXRSTlNDUDeS4aNr4ukAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAWSURBVAiZY2BiYWZiYGBgZGAGMxgZAQEaABuwiNxCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 81783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/portal.98c21457.png","height":77,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlNsWTFjgUEF1le7AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNgYWZkYGJlYmZgYGBiZGBkZgEAAT0AIO1XJrYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 92905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ CompaniesReel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/companies/airplane.png
/* harmony default export */ var airplane = ({"src":"/_next/static/media/airplane.ef0c6262.png","height":116,"width":475,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEUAAAAEBgkNEBgAAAAAAAAMAxcSCBsJCRXvGuWLAAAACHRSTlMjNG0aQA5Lg/S+FJEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVAiZY2BkZ2VmYGBgZmBiYmNgYWRhBAABhAAotSJibAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/basedash.png
var basedash = __webpack_require__(96088);
// EXTERNAL MODULE: ./public/images/companies/knock.png
var knock = __webpack_require__(29358);
;// CONCATENATED MODULE: ./public/images/companies/pipe.png
/* harmony default export */ var pipe = ({"src":"/_next/static/media/pipe.b1c6ce16.png","height":115,"width":394,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUUeIgAAAACXRSTlOAoI0vlG5lR8bcG/bfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNgZGRmYmJiYGHgYGZnYmVkYwAAAYIAMNAScEcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/impira.png
var impira = __webpack_require__(12066);
// EXTERNAL MODULE: ./public/images/companies/portal.png
var portal = __webpack_require__(81783);
;// CONCATENATED MODULE: ./public/images/companies/hightouch.png
/* harmony default export */ var hightouch = ({"src":"/_next/static/media/hightouch.999a8962.png","height":169,"width":531,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUEBQgFBQgFBQgFBQgFBQgFBQgFBQgFBQgFBQgc8PHuAAAACXRSTlMEKll3ZzgOGU+PJIYuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgYGBjYAARLMzMLCwcTCwMrEzsjKyMjOwAA00ASmiPEu4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/images/companies/dripos.png
/* harmony default export */ var dripos = ({"src":"/_next/static/media/dripos.5d498b60.png","height":72,"width":304,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAASAQCkAAAAB3RSTlNnUVyKMTN/stixzgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABdJREFUCJljYGZhZmQAQQYWBlY2RiYmAAEsACI8HrcnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/mage.png
var mage = __webpack_require__(75428);
;// CONCATENATED MODULE: ./public/images/companies/secoda.svg
/* harmony default export */ var secoda = ({"src":"/_next/static/media/secoda.c127824d.svg","height":23,"width":135});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx

















const CompaniesReel = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).anchorFeature,
        id: "customers",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Home_module_default()).anchorHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Our customers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                        type: "copy2",
                        onDark: true,
                        children: [
                            "Highlight powers forward-thinking companies.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/customers",
                                children: "Find out more about our customers →"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Home_module_default()).customerReel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Home_module_default()).companies,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: pipe,
                            alt: "Pipe",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(0.9)"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: portal/* default */.Z,
                            alt: "Portal",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: dripos,
                            alt: "Dripos",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: knock/* default */.Z,
                            alt: "Knock",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: hightouch,
                            alt: "Hightouch",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(1.1)"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: basedash/* default */.Z,
                            alt: "Basedash"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: impira/* default */.Z,
                            alt: "Impira",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: mage/* default */.Z,
                            alt: "Mage",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: airplane,
                            alt: "Airplane",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Home_module_default()).tabletGraphic, (Home_module_default()).hideMobile)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: secoda,
                            alt: "Secoda",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(0.8)"
                            }
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 62223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50246);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Section = (param)=>{
    let { reverseMobile , className , children , noYBottomPadding , noYTopPadding , grid , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), {
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionReverseMobile)]: reverseMobile,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYTopPadding)]: noYTopPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYBottomPadding)]: noYBottomPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gridSection)]: grid
        }),
        children: children
    });
};


/***/ }),

/***/ 23226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/images/checkmark.svg
/* harmony default export */ var checkmark = ({"src":"/_next/static/media/checkmark.902c766c.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/pc-play-media.svg
/* harmony default export */ var pc_play_media = ({"src":"/_next/static/media/pc-play-media.0e69c013.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/images/wallet.svg
/* harmony default export */ var wallet = ({"src":"/_next/static/media/wallet.9df2c29b.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/stopwatch.svg
/* harmony default export */ var stopwatch = ({"src":"/_next/static/media/stopwatch.4a134a7c.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/images/globe.svg
/* harmony default export */ var globe = ({"src":"/_next/static/media/globe.1dc90133.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/security.svg
/* harmony default export */ var security = ({"src":"/_next/static/media/security.2681f794.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/receipt-list.svg
/* harmony default export */ var receipt_list = ({"src":"/_next/static/media/receipt-list.5cb65368.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/credit-card.svg
/* harmony default export */ var credit_card = ({"src":"/_next/static/media/credit-card.212878e6.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/delete.svg
/* harmony default export */ var images_delete = ({"src":"/_next/static/media/delete.1278a3f5.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/tag-loyalty.svg
/* harmony default export */ var tag_loyalty = ({"src":"/_next/static/media/tag-loyalty.2daf62a8.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/pricing-comment.svg
/* harmony default export */ var pricing_comment = ({"src":"/_next/static/media/pricing-comment.b1931d70.svg","height":24,"width":24});
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 3 modules
var Navbar = __webpack_require__(77911);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/Pricing/Pricing.module.scss
var Pricing_module = __webpack_require__(8962);
var Pricing_module_default = /*#__PURE__*/__webpack_require__.n(Pricing_module);
// EXTERNAL MODULE: ./components/Products/Products.module.scss
var Products_module = __webpack_require__(49879);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx + 5 modules
var CompaniesReel = __webpack_require__(92905);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js + 1 modules
var embla_carousel_react_esm = __webpack_require__(57434);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./components/Pricing/plan_features.tsx
const BasicDetails = {
    features: {
        name: "Features",
        items: [
            {
                name: "Public session sharing",
                value: false
            },
            {
                name: "Custom data export",
                value: false
            },
            {
                name: "Enhanced user properties",
                value: false
            },
            {
                name: "Session / error commenting",
                value: true
            }
        ]
    },
    teamManagement: {
        name: "Team Management",
        items: [
            {
                name: "Role-based access control",
                value: false
            },
            {
                name: "Single sign-on",
                value: false
            },
            {
                name: "Two-factor authentication",
                value: false
            }
        ]
    },
    support: {
        name: "Support",
        items: [
            {
                name: "Email",
                value: true
            },
            {
                name: "Intercom",
                value: true
            },
            {
                name: "Slack Connect",
                value: false
            },
            {
                name: "24x7 support with SLAs",
                value: false
            }
        ]
    }
};
const EssentialsDetails = {
    features: {
        name: "Features",
        items: [
            {
                name: "Public session sharing",
                value: false
            },
            {
                name: "Custom data export",
                value: false
            },
            {
                name: "Enhanced user properties",
                value: false
            },
            {
                name: "Session / error commenting",
                value: true
            }
        ]
    },
    teamManagement: {
        name: "Team Management",
        items: [
            {
                name: "Role-based access control",
                value: false
            },
            {
                name: "Single sign-on",
                value: false
            },
            {
                name: "Two-factor authentication",
                value: false
            }
        ]
    },
    support: {
        name: "Support",
        items: [
            {
                name: "Email",
                value: true
            },
            {
                name: "Intercom",
                value: true
            },
            {
                name: "Slack Connect",
                value: false
            },
            {
                name: "24x7 support with SLAs",
                value: false
            }
        ]
    }
};
const StartupDetails = {
    features: {
        name: "Features",
        items: [
            {
                name: "Public session sharing",
                value: true
            },
            {
                name: "Custom data export",
                value: false
            },
            {
                name: "Enhanced user properties",
                value: true
            },
            {
                name: "Session / error commenting",
                value: true
            }
        ]
    },
    teamManagement: {
        name: "Team Management",
        items: [
            {
                name: "Role-based access control",
                value: true
            },
            {
                name: "Single sign-on",
                value: true
            },
            {
                name: "Two-factor authentication",
                value: true
            }
        ]
    },
    support: {
        name: "Support",
        items: [
            {
                name: "Email",
                value: true
            },
            {
                name: "Intercom",
                value: true
            },
            {
                name: "Slack Connect",
                value: true
            },
            {
                name: "24x7 support with SLAs",
                value: false
            }
        ]
    }
};
const EnterpriseDetails = {
    features: {
        name: "Features",
        items: [
            {
                name: "Public session sharing",
                value: true
            },
            {
                name: "Custom data export",
                value: true
            },
            {
                name: "Enhanced user properties",
                value: true
            },
            {
                name: "Session / error commenting",
                value: true
            }
        ]
    },
    teamManagement: {
        name: "Team Management",
        items: [
            {
                name: "Role-based access control",
                value: true
            },
            {
                name: "Single sign-on",
                value: true
            },
            {
                name: "Two-factor authentication",
                value: true
            }
        ]
    },
    support: {
        name: "Support",
        items: [
            {
                name: "Email",
                value: true
            },
            {
                name: "Intercom",
                value: true
            },
            {
                name: "Slack Connect",
                value: true
            },
            {
                name: "24x7 support with SLAs",
                value: true
            }
        ]
    }
};

;// CONCATENATED MODULE: ./components/Pricing/plan_info.tsx
const BasicInfo = {
    tierName: "Basic",
    numSessionCredits: 500,
    price: 0,
    mostPopular: false,
    discount: 0
};
const EssentialsInfo = {
    tierName: "Essentials",
    numSessionCredits: 10000,
    price: 150,
    mostPopular: false,
    discount: 20
};
const StartupInfo = {
    tierName: "Startup",
    numSessionCredits: 80000,
    price: 400,
    mostPopular: true,
    discount: 20
};
const EnterpriseInfo = {
    tierName: "Enterprise",
    numSessionCredits: 0,
    mostPopular: false
};

// EXTERNAL MODULE: ./components/common/Head/Meta.tsx
var Meta = __webpack_require__(50745);
// EXTERNAL MODULE: ./components/MediaQuery/MediaQuery.tsx
var MediaQuery = __webpack_require__(70358);
;// CONCATENATED MODULE: ./pages/pricing/index.tsx































// Plans and info used for both mobile and desktop views.
const planDetails = [
    BasicDetails,
    EssentialsDetails,
    StartupDetails,
    EnterpriseDetails
];
const planInfo = [
    BasicInfo,
    EssentialsInfo,
    StartupInfo,
    EnterpriseInfo
];
const docsUrl = "/docs";
const FAQS = [
    {
        question: "Do you offer a discount for non-profits?",
        answer: "We love supporting non-profits and offer a 75% discount for the lifetime of the account. To activate the discount, create a workplace on either the Standard or Pro plan. Then reach out to support and mention the discount. ",
        icon: tag_loyalty
    },
    {
        question: "How long does it take to setup Highlight?",
        answer: 'It generally takes an engineer less than ten minutes to understand the concepts of Highlight and integrate the app into their workflow. For more information on setup, take a look at our <a href="'.concat(docsUrl, '">docs</a>. '),
        icon: stopwatch
    },
    {
        question: "Can I deploy Highlight on-premise?",
        answer: 'Yes! To get a glimpse at how our deployment process looks, take a look <a href="'.concat(docsUrl, '/on-premise">here</a> (its super simple!). We also support deployments for most cloud providers (Heroku, Render, AWS, etc..). To get a license key for a trial or a production deployment, contact <a href="mailto:sales@highlight.io">sales</a>. '),
        icon: globe
    },
    {
        question: "Is Highlight secure? Where's my data stored?",
        answer: 'Highlight uses end-to-end encryption to keep your data safe while it’s in transit, and we also offer an on-prem solution if you want to keep customer data on your own servers. For more information, see our <a href="/#privacy">security section</a> and <a href="'.concat(docsUrl, '" target="_blank">docs</a>. If we don\'t answer your question there, <a href="mailto:jay@highlight.io">let us know</a>. '),
        icon: security
    },
    {
        question: "Do I need a credit card to sign up?",
        answer: "Absolutely not! We never ask for your credit card on sign up. If you start on a paid plan then 30 days after signing up you will be politely prompted to enter in your payment information. At anytime you can switch back to a free plan as long as your workplace has less than 6 seats. ",
        icon: credit_card
    },
    {
        question: "How will you charge me?",
        answer: 'We ask for a credit card. Your credit card information will never touch our servers as we use <a href="https://stripe.com/" target="_blank">Stripe</a> as our payments processor. For Enterprise customers we can do ACH and custom invoices if requested. ',
        icon: wallet
    },
    {
        question: "How does billing work?",
        answer: "We charge by usage; or number of sessions collected per month. Our billing system uses prorated billing, meaning you only pay for what you use below each of our thresholds (see above). For example if you move to the Startup plan from the Basic plan in the middle of the month, then you will only be charged for the time you are on the paid plan. ",
        icon: receipt_list
    },
    {
        question: "What counts as a session?",
        answer: "A session is contiguous instance of a user's presence on your app for less than 4 hours. That is, if a user is browsing your application for 3 minutes, then closes the tab, this counts as a single session. ",
        icon: pc_play_media
    },
    {
        question: "Can I cancel at anytime?",
        answer: "Definitely! You can cancel or downgrade your subscription at anytime. You can also delete your workplace in the settings page at anytime. ",
        icon: images_delete
    }
];
const TierSection = (param)=>{
    let { tierName , numSessionCredits , price , discount , features , mostPopular , monthly  } = param;
    const contactSales = price === undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            mostPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Pricing_module_default()).mostPopular,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    type: "outline",
                    children: "Most Popular"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Pricing_module_default()).tierColumn, {
                    [(Pricing_module_default()).mostPopularTierColumn]: mostPopular
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Pricing_module_default()).desktopTierSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Pricing_module_default()).desktopTopTier,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Pricing_module_default()).tierHeader,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy1",
                                                emphasis: true,
                                                children: tierName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((Pricing_module_default()).discountPill, {
                                                    [(Pricing_module_default()).discountPillVisible]: !monthly && discount
                                                }),
                                                children: [
                                                    "- ",
                                                    discount,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    contactSales ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Pricing_module_default()).desktopSessionCreditsEnterprise,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                emphasis: true,
                                                children: "Custom"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                children: " session credits"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Pricing_module_default()).desktopSessionCredits,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                emphasis: true,
                                                children: numSessionCredits.toLocaleString()
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                children: " session credits"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Pricing_module_default()).desktopPrice,
                                        children: contactSales ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            height: 24,
                                            width: 24,
                                            src: pricing_comment,
                                            alt: "chat icon"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    className: (Pricing_module_default()).moneySign,
                                                    children: "$"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: (Pricing_module_default()).price,
                                                    children: monthly || !discount ? price : Math.round((1 - discount / 100) * price)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Pricing_module_default()).timeIndicator,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy3",
                                                        children: "/ mo"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                href: contactSales ? "mailto:sales@highlight.io" : "https://app.highlight.io/?sign_up=1",
                                className: (Pricing_module_default()).pricingButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: contactSales ? "Contact Sales" : "Start Free Trial"
                                })
                            })
                        ]
                    }),
                    features && Object.keys(features).map((headingKey)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Pricing_module_default()).desktopFeaturesSection,
                            children: features[headingKey].items.map((item)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        item.value ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: checkmark,
                                            alt: "checkmark"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: (Pricing_module_default()).featureDivider
                                        })
                                    ]
                                });
                            })
                        }, headingKey);
                    })
                ]
            })
        ]
    });
};
const Pricing = ()=>{
    const [monthly, setMonthly] = (0,react.useState)(true);
    const is800 = (0,MediaQuery/* useMediaQuery */.a)(800);
    const is400 = (0,MediaQuery/* useMediaQuery */.a)(400);
    const isMobile = is800 || is400;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Highlight: Plans And Pricing For Any Team. Get Started Free."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: '{\n            "@context": "https://schema.org",\n            "@type": "FAQPage",\n            "mainEntity":\n              '.concat(JSON.stringify(FAQS.map((faq)=>({
                                "@type": "Question",
                                name: faq.question,
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: faq.answer
                                }
                            }))), "\n          }")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
                title: "Highlight: Plans And Pricing For Any Team. Get Started Free.",
                description: "Highlight's developer friendly pricing makes sure any team can afford to get the visibility into bugs they need. See plans, features, FAQs and more here:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        className: (Pricing_module_default()).titleSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Pricing_module_default()).pricingTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Pricing_module_default()).anchorHead,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Products_module_default()).highlightedBadge,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy4",
                                            emphasis: true,
                                            children: "Plans and Pricing"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        children: [
                                            "Get the",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Pricing_module_default()).yellowText,
                                                children: " visibility "
                                            }),
                                            "you need today."
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
                        className: (Pricing_module_default()).mobileTierWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Pricing_module_default()).mobileBillingWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        className: (Pricing_module_default()).billingCycleText,
                                        children: "Select billing cycle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BillingWidget, {
                                        onMonthlyChange: (m)=>setMonthly(m),
                                        monthly: monthly
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTierCarousel, {
                                monthly: monthly
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
                        className: (Pricing_module_default()).tierWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Pricing_module_default()).configColumn,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BillingWidget, {
                                        onMonthlyChange: (m)=>setMonthly(m),
                                        monthly: monthly
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Pricing_module_default()).featureKeys,
                                        children: Object.keys(BasicDetails).map((headingKey)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Pricing_module_default()).featureSet,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        className: (Pricing_module_default()).featureName,
                                                        type: "copy3",
                                                        emphasis: true,
                                                        children: BasicDetails[headingKey].name
                                                    }),
                                                    BasicDetails[headingKey].items.map((item, key)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                                    type: "copy3",
                                                                    className: (Pricing_module_default()).featureKey,
                                                                    onDark: true,
                                                                    children: item.name
                                                                }, key),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                                    className: (Pricing_module_default()).featureKeyDivider
                                                                })
                                                            ]
                                                        });
                                                    })
                                                ]
                                            }, headingKey);
                                        })
                                    })
                                ]
                            }),
                            planInfo.map((p, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TierSection, {
                                    features: planDetails[idx],
                                    monthly: monthly,
                                    ...p
                                }, idx))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesReel/* CompaniesReel */.T, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
                        className: (Pricing_module_default()).faqSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Pricing_module_default()).anchorFeature,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Pricing_module_default()).anchorHead,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Frequently asked questions"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: FAQS.map((faq, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
                                        question: faq.question,
                                        answer: faq.answer,
                                        icon: faq.icon
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
const DownArrow = (param)=>/*#__PURE__*/ {
    let { fill  } = param;
    return (0,jsx_runtime.jsxs)("svg", {
        width: 12,
        height: 12,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.625 3.375 6 9 .375 3.375",
                    stroke: fill,
                    strokeWidth: 2,
                    strokeMiterlimit: 10
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: fill,
                        d: "M0 0h12v12H0z"
                    })
                })
            })
        ]
    });
};
const Question = (param)=>{
    let { question , answer , icon  } = param;
    const [expanded, setExpanded] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Pricing_module_default()).faqRowClickable,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                onOpening: ()=>setExpanded(true),
                onClosing: ()=>setExpanded(false),
                transitionTime: 200,
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Pricing_module_default()).faqRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Pricing_module_default()).faqLeftContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: icon,
                                    alt: "pc icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    className: (Pricing_module_default()).question,
                                    type: "copy2",
                                    emphasis: true,
                                    children: question
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: classnames_default()((Pricing_module_default()).circleButton, {
                                [(Pricing_module_default()).expanded]: expanded
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownArrow, {
                                fill: expanded ? "#0D0225" : "#72E4FC"
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Pricing_module_default()).collapseInner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        className: (Pricing_module_default()).questionDescription,
                        type: "copy3",
                        onDark: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: answer
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: (Pricing_module_default()).faqDivider
            })
        ]
    });
};
const BillingWidget = (param)=>{
    let { monthly , onMonthlyChange  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Pricing_module_default()).billingWidget,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Pricing_module_default()).billingWidgetButtons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                        className: classnames_default()((Pricing_module_default()).billingButton, (Pricing_module_default()).leftButton, {
                            [(Pricing_module_default()).selected]: monthly
                        }),
                        onClick: ()=>onMonthlyChange(true),
                        children: "Monthly"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                        className: classnames_default()((Pricing_module_default()).billingButton, (Pricing_module_default()).rightButton, {
                            [(Pricing_module_default()).selected]: !monthly
                        }),
                        onClick: ()=>onMonthlyChange(false),
                        children: "Annual"
                    })
                ]
            })
        })
    });
};
const MobileTierCarousel = (param)=>{
    let { monthly  } = param;
    const { width  } = useWindowDimensions();
    const [planIndex, setPlanIndex] = (0,react.useState)(2);
    const [viewportRef, embla] = (0,embla_carousel_react_esm/* default */.Z)({
        startIndex: planIndex,
        align: "center"
    });
    (0,react.useEffect)(()=>{
        if (embla && planIndex) {
            embla.scrollTo(planIndex);
            embla.on("select", ()=>{
                setPlanIndex(embla.selectedScrollSnap());
            });
        }
    }, [
        embla,
        planIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embla",
                ref: viewportRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "embla__container",
                    children: planInfo.map((p, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTierSection, {
                            width: width <= 800 ? 248 : 332,
                            selected: i == planIndex,
                            monthly: monthly,
                            ...p
                        }, i))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Pricing_module_default()).mobileTierDots,
                children: planInfo.map((p, i)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                        onClick: ()=>{
                            embla === null || embla === void 0 ? void 0 : embla.scrollTo(i, false);
                        },
                        className: classnames_default()((Pricing_module_default()).mobileTierDot, {
                            [(Pricing_module_default()).dotSelected]: i == planIndex
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Pricing_module_default()).mobileFeaturesWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    type: "copy3",
                    emphasis: true,
                    children: Object.keys(planDetails[planIndex]).map((headingKey)=>{
                        let currentFeatureSection = planDetails[planIndex][headingKey];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Pricing_module_default()).mobileFeaturesSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Pricing_module_default()).mobileFeatureHeader,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: currentFeatureSection.name
                                    })
                                }),
                                Object.keys(currentFeatureSection.items).map((featureKey, i)=>{
                                    let currentFeature = currentFeatureSection.items[featureKey];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Pricing_module_default()).mobileFeatureRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Pricing_module_default()).mobileFeatureInner,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy3",
                                                        className: (Pricing_module_default()).mobileFeatureName,
                                                        children: currentFeature.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy3",
                                                        children: currentFeature.value == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: checkmark,
                                                            alt: "checkmark"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "-"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                className: (Pricing_module_default()).mobileFeatureDivider
                                            })
                                        ]
                                    }, i);
                                })
                            ]
                        }, headingKey);
                    })
                })
            })
        ]
    });
};
const MobileTierSection = (param)=>{
    let { tierName , numSessionCredits , price , mostPopular , selected , width , discount , monthly  } = param;
    const contactSales = price === undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            minWidth: width
        },
        className: classnames_default()((Pricing_module_default()).mobileTierSectionWrapper, "embla__slide", {
            [(Pricing_module_default()).mobileNotSelectedPlan]: !selected
        }),
        children: [
            mostPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Pricing_module_default()).mostPopularMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    type: "outline",
                    children: "Most Popular"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Pricing_module_default()).mobileTier, {
                    [(Pricing_module_default()).mostPopularTierColumnMobile]: mostPopular
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Pricing_module_default()).mobileTierTop,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Pricing_module_default()).tierHeader,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy1",
                                        emphasis: true,
                                        children: tierName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((Pricing_module_default()).discountPill, {
                                            [(Pricing_module_default()).discountPillVisible]: !monthly && discount
                                        }),
                                        children: [
                                            "- ",
                                            discount,
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                type: "copy3",
                                className: (Pricing_module_default()).mobileSessionCredits,
                                children: [
                                    numSessionCredits ? numSessionCredits.toLocaleString() : "Custom",
                                    " ",
                                    "session credits"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Pricing_module_default()).desktopPrice,
                                children: contactSales ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    height: 24,
                                    width: 24,
                                    src: pricing_comment,
                                    alt: "chat icon"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy3",
                                            emphasis: true,
                                            className: (Pricing_module_default()).moneySign,
                                            children: "$"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (Pricing_module_default()).price,
                                            children: monthly || !discount ? price : Math.round((1 - discount / 100) * price)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Pricing_module_default()).timeIndicator,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                children: "/ mo"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                        className: classnames_default()((Pricing_module_default()).pricingButton, (Pricing_module_default()).mobilePricingButton),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "copy2",
                            emphasis: true,
                            children: contactSales ? "Contact Sales" : "Start Free Trial"
                        })
                    })
                ]
            })
        ]
    });
};
function getWindowDimensions() {
    const { innerWidth: width , innerHeight: height  } = window;
    return {
        width,
        height
    };
}
function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = (0,react.useState)(getWindowDimensions());
    (0,react.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
}
/* harmony default export */ var pricing = (Pricing);


/***/ }),

/***/ 8962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pricingTable":"Pricing_pricingTable__PGmEh","checkmark":"Pricing_checkmark__ofAZZ","mobileTiers":"Pricing_mobileTiers__hG3Nk","anchorHead":"Pricing_anchorHead___QAmp","tierWrapper":"Pricing_tierWrapper__wAApk","moneySign":"Pricing_moneySign__pnxrP","pricingButton":"Pricing_pricingButton__Oq2yl","timeIndicator":"Pricing_timeIndicator__UUbFS","price":"Pricing_price__ePdl0","desktopPrice":"Pricing_desktopPrice__RSthE","tierHeader":"Pricing_tierHeader__uRuuv","discountPill":"Pricing_discountPill__Lo8UM","discountPillVisible":"Pricing_discountPillVisible__CY_sp","desktopSessionCredits":"Pricing_desktopSessionCredits__IBfYH","desktopSessionCreditsEnterprise":"Pricing_desktopSessionCreditsEnterprise__RboQQ","mostPopular":"Pricing_mostPopular__WZrVx","configColumn":"Pricing_configColumn__QmhJe","featureName":"Pricing_featureName__OsKvD","featureSet":"Pricing_featureSet__E_ecM","featureKey":"Pricing_featureKey__ZWHN_","featureKeys":"Pricing_featureKeys__wrVSt","billingCopy":"Pricing_billingCopy__Hz9XY","billingWidget":"Pricing_billingWidget__PvvTX","billingWidgetButtons":"Pricing_billingWidgetButtons__npfV9","billingButton":"Pricing_billingButton__WKrTi","rightButton":"Pricing_rightButton__dlPan","leftButton":"Pricing_leftButton__piK9w","selected":"Pricing_selected__pLvlG","tierColumn":"Pricing_tierColumn__gakOZ","desktopTopTier":"Pricing_desktopTopTier__s5mtq","mostPopularTierColumn":"Pricing_mostPopularTierColumn__QgDa9","desktopTierSection":"Pricing_desktopTierSection__gmNrj","mobileFeatureDivider":"Pricing_mobileFeatureDivider__dt7T4","featureDivider":"Pricing_featureDivider__HDgep","circleButton":"Pricing_circleButton__XP0yW","expanded":"Pricing_expanded__1ILqR","faqRowClickable":"Pricing_faqRowClickable__yBBcV","faqDivider":"Pricing_faqDivider__EZ9_i","featureKeyDivider":"Pricing_featureKeyDivider__9fz0c","desktopFeaturesSection":"Pricing_desktopFeaturesSection__t_kxB","mobileFeaturesSection":"Pricing_mobileFeaturesSection__JPu3R","sectionSubtitle":"Pricing_sectionSubtitle__SVzdA","yellowText":"Pricing_yellowText__mkwlu","pricingTitle":"Pricing_pricingTitle__cHmUr","mobileNotSelectedPlan":"Pricing_mobileNotSelectedPlan__niGJ_","mobileBillingWrapper":"Pricing_mobileBillingWrapper__Zo_q3","mostPopularTierColumnMobile":"Pricing_mostPopularTierColumnMobile__i_Ipo","mobileFeaturesWrapper":"Pricing_mobileFeaturesWrapper__kV_dl","mobileFeatureRow":"Pricing_mobileFeatureRow__DubyA","mostPopularMobile":"Pricing_mostPopularMobile__cBOGq","mobileFeatureHeader":"Pricing_mobileFeatureHeader__7jUJH","mobileTierCarousel":"Pricing_mobileTierCarousel__hpU6r","mobileFeatureInner":"Pricing_mobileFeatureInner__qw8GL","mobileFeatureName":"Pricing_mobileFeatureName__bpLyU","carousel-div":"Pricing_carousel-div__lkV_g","billingCycleText":"Pricing_billingCycleText__t0VP_","mobileCarousel":"Pricing_mobileCarousel__unoKl","mobileSessionCredits":"Pricing_mobileSessionCredits__HlwFX","mobileTier":"Pricing_mobileTier__0qdHO","mobileTierTop":"Pricing_mobileTierTop__CO3FV","mobilePricingButton":"Pricing_mobilePricingButton__w_Vvb","mobileTierSectionWrapper":"Pricing_mobileTierSectionWrapper__1Lo0U","mobileTierDots":"Pricing_mobileTierDots__ynOox","mobileTierDot":"Pricing_mobileTierDot__2oZpv","dotSelected":"Pricing_dotSelected__g3Vjy","mobileTierWrapper":"Pricing_mobileTierWrapper__cEG8T","customerSection":"Pricing_customerSection__cXX7e","titleSection":"Pricing_titleSection__r8ZSe","question":"Pricing_question__u_oN0","questionDescription":"Pricing_questionDescription__fE1wp","collapseInner":"Pricing_collapseInner__WcO49","faqSection":"Pricing_faqSection__jLmlz","faqRow":"Pricing_faqRow__iyzQl","faqLeftContent":"Pricing_faqLeftContent__od6Hq","anchorFeaturePricing":"Pricing_anchorFeaturePricing__9tAVB","anchorFeature":"Pricing_anchorFeature__aL7tH","buttonContainer":"Pricing_buttonContainer__MypOJ","anchorTitle":"Pricing_anchorTitle__ldDVS","anchorImage":"Pricing_anchorImage__CyZHo","secondaryAnchor":"Pricing_secondaryAnchor__aHoZZ","mobileTierCard":"Pricing_mobileTierCard__xanQy","tableCard":"Pricing_tableCard__eJa04","tierInfo":"Pricing_tierInfo__lkeSJ","tierName":"Pricing_tierName__EZJoy","tierPrice":"Pricing_tierPrice__9HQ0k","priceNum":"Pricing_priceNum__wcPxs","priceDuration":"Pricing_priceDuration__Y1Dk_","startTrial":"Pricing_startTrial__uuCAn","pricingBreakdown":"Pricing_pricingBreakdown__Yrr7u","tableBody":"Pricing_tableBody__V5ppA"};

/***/ }),

/***/ 50246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2Pzmc","gridSection":"Section_gridSection__vgdkS","noYTopPadding":"Section_noYTopPadding__CWdmK","noYBottomPadding":"Section_noYBottomPadding__efv2e","sectionReverseMobile":"Section_sectionReverseMobile__q0tjM"};

/***/ }),

/***/ 97893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){if(true)module.exports=t(__webpack_require__(67294));else { var r, n; }}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=4)}([function(e,t,n){e.exports=n(2)()},function(t,n){t.exports=e},function(e,t,n){"use strict";var r=n(3);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,s){if(s!==r){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}e.isRequired=e;var n={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";n.r(t);var r=n(1),o=n.n(r),i=n(0),s=n.n(i),a=function(e){return 0!==e};function l(){return(l=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function c(e){return(c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function p(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function u(e,t){return(u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e})(e,t)}function g(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=d(e);if(t){var o=d(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return f(this,n)}}function f(e,t){if(t&&("object"===c(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return h(e)}function h(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function b(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var m=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&u(e,t)}(s,e);var t,n,r,i=g(s);function s(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),b(h(t=i.call(this,e)),"continueOpenCollapsible",(function(){var e=h(t).innerRef;t.setState({height:e.scrollHeight,transition:"height ".concat(t.props.transitionTime,"ms ").concat(t.props.easing),isClosed:!1,hasBeenOpened:!0,inTransition:a(e.scrollHeight),shouldOpenOnNextCycle:!1})})),b(h(t),"handleTriggerClick",(function(e){t.props.triggerDisabled||t.state.inTransition||(e.preventDefault(),t.props.handleTriggerClick?t.props.handleTriggerClick(t.props.accordionPosition):!0===t.state.isClosed?(t.openCollapsible(),t.props.onOpening(),t.props.onTriggerOpening()):(t.closeCollapsible(),t.props.onClosing(),t.props.onTriggerClosing()))})),b(h(t),"handleTransitionEnd",(function(e){e.target===t.innerRef&&(t.state.isClosed?(t.setState({inTransition:!1}),t.props.onClose()):(t.setState({height:"auto",overflow:t.props.overflowWhenOpen,inTransition:!1}),t.props.onOpen()))})),b(h(t),"setInnerRef",(function(e){return t.innerRef=e})),t.timeout=void 0,t.contentId=e.contentElementId||"collapsible-content-".concat(Date.now()),t.triggerId=e.triggerElementProps.id||"collapsible-trigger-".concat(Date.now()),e.open?t.state={isClosed:!1,shouldSwitchAutoOnNextCycle:!1,height:"auto",transition:"none",hasBeenOpened:!0,overflow:e.overflowWhenOpen,inTransition:!1}:t.state={isClosed:!0,shouldSwitchAutoOnNextCycle:!1,height:0,transition:"height ".concat(e.transitionTime,"ms ").concat(e.easing),hasBeenOpened:!1,overflow:"hidden",inTransition:!1},t}return t=s,(n=[{key:"componentDidUpdate",value:function(e,t){var n=this;this.state.shouldOpenOnNextCycle&&this.continueOpenCollapsible(),"auto"!==t.height&&0!==t.height||!0!==this.state.shouldSwitchAutoOnNextCycle||(window.clearTimeout(this.timeout),this.timeout=window.setTimeout((function(){n.setState({height:0,overflow:"hidden",isClosed:!0,shouldSwitchAutoOnNextCycle:!1})}),50)),e.open!==this.props.open&&(!0===this.props.open?(this.openCollapsible(),this.props.onOpening()):(this.closeCollapsible(),this.props.onClosing()))}},{key:"componentWillUnmount",value:function(){window.clearTimeout(this.timeout)}},{key:"closeCollapsible",value:function(){var e=this.innerRef;this.setState({shouldSwitchAutoOnNextCycle:!0,height:e.scrollHeight,transition:"height ".concat(this.props.transitionCloseTime?this.props.transitionCloseTime:this.props.transitionTime,"ms ").concat(this.props.easing),inTransition:a(e.scrollHeight)})}},{key:"openCollapsible",value:function(){this.setState({inTransition:a(this.innerRef.scrollHeight),shouldOpenOnNextCycle:!0})}},{key:"renderNonClickableTriggerElement",value:function(){var e=this.props,t=e.triggerSibling,n=e.classParentString;if(!t)return null;switch(c(t)){case"string":return o.a.createElement("span",{className:"".concat(n,"__trigger-sibling")},t);case"function":return t();case"object":return t;default:return null}}},{key:"render",value:function(){var e=this,t={height:this.state.height,WebkitTransition:this.state.transition,msTransition:this.state.transition,transition:this.state.transition,overflow:this.state.overflow},n=this.state.isClosed?"is-closed":"is-open",r=this.props.triggerDisabled?"is-disabled":"",i=!1===this.state.isClosed&&void 0!==this.props.triggerWhenOpen?this.props.triggerWhenOpen:this.props.trigger,s=this.props.contentContainerTagName,a=this.props.triggerTagName,c=this.props.lazyRender&&!this.state.hasBeenOpened&&this.state.isClosed&&!this.state.inTransition?null:this.props.children,p=this.props,u=p.classParentString,g=p.contentOuterClassName,f=p.contentInnerClassName,h="".concat(u,"__trigger ").concat(n," ").concat(r," ").concat(this.state.isClosed?this.props.triggerClassName:this.props.triggerOpenedClassName),d="".concat(u," ").concat(this.state.isClosed?this.props.className:this.props.openedClassName),b="".concat(u,"__contentOuter ").concat(g),m="".concat(u,"__contentInner ").concat(f);return o.a.createElement(s,l({className:d.trim()},this.props.containerElementProps),o.a.createElement(a,l({id:this.triggerId,className:h.trim(),onClick:this.handleTriggerClick,style:this.props.triggerStyle&&this.props.triggerStyle,onKeyPress:function(t){var n=t.key;(" "===n&&"button"!==e.props.triggerTagName.toLowerCase()||"Enter"===n)&&e.handleTriggerClick(t)},tabIndex:this.props.tabIndex&&this.props.tabIndex,"aria-expanded":!this.state.isClosed,"aria-disabled":this.props.triggerDisabled,"aria-controls":this.contentId,role:"button"},this.props.triggerElementProps),i),this.renderNonClickableTriggerElement(),o.a.createElement("div",{id:this.contentId,className:b.trim(),style:t,onTransitionEnd:this.handleTransitionEnd,ref:this.setInnerRef,hidden:this.props.contentHiddenWhenClosed&&this.state.isClosed&&!this.state.inTransition,role:"region","aria-labelledby":this.triggerId},o.a.createElement("div",{className:m.trim()},c)))}}])&&p(t.prototype,n),r&&p(t,r),Object.defineProperty(t,"prototype",{writable:!1}),s}(r.Component);m.propTypes={transitionTime:s.a.number,transitionCloseTime:s.a.number,triggerTagName:s.a.string,easing:s.a.string,open:s.a.bool,containerElementProps:s.a.object,triggerElementProps:s.a.object,contentElementId:s.a.string,classParentString:s.a.string,className:s.a.string,openedClassName:s.a.string,triggerStyle:s.a.object,triggerClassName:s.a.string,triggerOpenedClassName:s.a.string,contentOuterClassName:s.a.string,contentInnerClassName:s.a.string,accordionPosition:s.a.oneOfType([s.a.string,s.a.number]),handleTriggerClick:s.a.func,onOpen:s.a.func,onClose:s.a.func,onOpening:s.a.func,onClosing:s.a.func,onTriggerOpening:s.a.func,onTriggerClosing:s.a.func,trigger:s.a.oneOfType([s.a.string,s.a.element]),triggerWhenOpen:s.a.oneOfType([s.a.string,s.a.element]),triggerDisabled:s.a.bool,lazyRender:s.a.bool,overflowWhenOpen:s.a.oneOf(["hidden","visible","auto","scroll","inherit","initial","unset"]),contentHiddenWhenClosed:s.a.bool,triggerSibling:s.a.oneOfType([s.a.string,s.a.element,s.a.func]),tabIndex:s.a.number,contentContainerTagName:s.a.string,children:s.a.oneOfType([s.a.string,s.a.element])},m.defaultProps={transitionTime:400,transitionCloseTime:null,triggerTagName:"span",easing:"linear",open:!1,classParentString:"Collapsible",triggerDisabled:!1,lazyRender:!1,overflowWhenOpen:"hidden",contentHiddenWhenClosed:!1,openedClassName:"",triggerStyle:null,triggerClassName:"",triggerOpenedClassName:"",contentOuterClassName:"",contentInnerClassName:"",className:"",triggerSibling:null,onOpen:function(){},onClose:function(){},onOpening:function(){},onClosing:function(){},onTriggerOpening:function(){},onTriggerClosing:function(){},tabIndex:null,contentContainerTagName:"div",triggerElementProps:{}};t.default=m}])}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,3826,1003,7434,8795,7911,9774,2888,179], function() { return __webpack_exec__(83542); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);